// extracted by mini-css-extract-plugin
export default {"statsContainer":"TransfersStatsPanel_statsContainer__QEPhJ","statsItem":"TransfersStatsPanel_statsItem__Lpjh3"};